module.exports = __webpack_public_path__ + "static/mockup-59ccf380361040eba30a45469fb6af99.gif";